var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cellLinkType" }, [
    _vm.conditionsDict && _vm.conditionsDict.length
      ? _c("div", [
          _c(
            "span",
            {
              staticClass: "cursor-pointer",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleClick.apply(null, arguments)
                },
                mouseup: function ($event) {
                  if ("button" in $event && $event.button !== 1) return null
                  $event.stopPropagation()
                  return _vm.handleMiddleClick.apply(null, arguments)
                },
              },
            },
            [
              _c("div", {
                staticClass: "cellLinkType__div-text",
                attrs: { active: _vm.value, title: _vm.value },
                domProps: { innerHTML: _vm._s(_vm.getValueFromCondition) },
              }),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.conditionsDict || _vm.conditionsDict.length == 0
      ? _c("div", [
          _c(
            "span",
            {
              staticClass: "cursor-pointer",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleClick.apply(null, arguments)
                },
                mouseup: function ($event) {
                  if ("button" in $event && $event.button !== 1) return null
                  $event.stopPropagation()
                  return _vm.handleMiddleClick.apply(null, arguments)
                },
              },
            },
            [
              _c("span", { class: _vm.iconClass }),
              _vm._v(" "),
              _c("span", [_vm._v(" " + _vm._s(_vm.formattedValue))]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }